'use client';
import Typography from '@/components/atoms/typography';
import Spinner from '@/components/organisms/spinner';
import React, { useEffect, useRef, useState } from 'react';
import ActiveOrdersTable from './components/activeOrdersTable';
import { useStoreAndBusinessUnits } from '@/providers/store-and-business-units';
import { sdk } from '@/sdk/CommercetoolsSDK';
import { useParams } from 'next/navigation';

const WhereIsMyOrder = () => {
  const [loading, setLoading] = useState(false);
    const { locale } = useParams();
  
  const [orders, setOrders] = useState<any>();

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const { selectedBusinessUnit } = useStoreAndBusinessUnits();
  const extensions = sdk.composableCommerce;
  const hasOrderCalled = useRef<boolean>(false);

  useEffect(() => {
    hasOrderCalled.current = false;
  }, [currentPage]);

  useEffect(() => {
    if (hasOrderCalled.current) return;
    hasOrderCalled.current = true;
    async function manageOrders() {
      const requestData = {
        legalEntity: locale === 'au' ? 'AU01' : 'NZ01',
        accountNumber: "",
        pageNumber: currentPage,
        pageSize: itemsPerPage,
        isOpenOrder: 1,
      };

      const regex = /Calling extension(?: \S+)? failed/;
      const maxRetries = 3;
      const retryDelay = 1000; // 1 second delay between retries

      try {
        setLoading(true);
        let lastError: any;

        for (let attempt = 0; attempt < maxRetries; attempt++) {
          try {
            const response = await extensions.custom.activeOrders(JSON.stringify(requestData));
            if (response?.data.status === 200) {
              setOrders(response?.data?.data);
              return; // Success, exit the function
            }
          } catch (error: any) {
            lastError = error;
            const errorMessage = error?.message || error?.toString() || '';

            // Check if error matches the retry pattern
            if (regex.test(errorMessage) && attempt < maxRetries - 1) {
              console.warn(`Attempt ${attempt + 1} failed with extension error. Retrying...`);
              // Wait before retrying
              await new Promise(resolve => setTimeout(resolve, retryDelay * (attempt + 1)));
              continue;
            }

            // If it's not a retryable error or we've exhausted retries, throw
            throw error;
          }
        }
      } catch (error) {
        console.error('Error:', error);
      } finally {
        setLoading(false);
      }
    }
    manageOrders();
  }, [selectedBusinessUnit, currentPage]);

  return (
    <>
      {loading && <Spinner />}
      {loading && <div className="overlay fixed left-0 top-0 z-50 h-full w-full bg-gray-800 opacity-75"></div>}
      <div className="mb-5 mt-[45px]">
        <Typography className="!text-32 !font-medium !leading-9 text-[#000000]">
          Manage Orders
        </Typography>
      </div>
      <div className='min-h-[340px]' >
        {!orders?.items || orders?.items?.length === 0 ? (
          <div className='min-h-[350px] h-full w-full flex items-center justify-center'>
            <Typography className="my-4 text-center">No Orders found</Typography>
            </div>
        ) : (
          <ActiveOrdersTable
            details={orders}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        )}
      </div>
    </>
  );
};

export default WhereIsMyOrder;
